import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

import SuccessHandler from '../SuccessHandler'

/* private BrandConfigurationMailSettingsTypes */
import {
  Settings,
  _BrandConfigurationMailSetting
} from '../namespace-helper'

import _ from 'lodash'

const selectedBrandConfigurationMailSettingTemplate = {
  id: null,
  name: 'New Brand Mail Setting',
  smtp_server: null,
  smtp_sec_proto: null,
  smtp_port: null,
  smtp_user: null,
  smtp_password: null
}

export default {
  namespaced: true,
  state: {
    brandConfigurationMailSettings: [],
    allBrandConfigurationMailSettings: [],
    selectedBrandConfigurationMailSetting: _.cloneDeep(selectedBrandConfigurationMailSettingTemplate),
    openDialog: false
  },
  mutations: {
    [_BrandConfigurationMailSetting.mutations.setBrandConfigurationMailSettings] (state, payload) {
      state.brandConfigurationMailSettings = payload
    },
    [_BrandConfigurationMailSetting.mutations.setAllBrandConfigurationMailSettings] (state, payload) {
      state.allBrandConfigurationMailSettings = payload
    },
    [_BrandConfigurationMailSetting.mutations.setSelectedBrandConfigurationMailSettings] (state, payload) {
      if (payload !== null) {
        state.selectedBrandConfigurationMailSetting = payload
      } else {
        state.selectedBrandConfigurationMailSetting = _.cloneDeep(selectedBrandConfigurationMailSettingTemplate)
      }
    },
    [_BrandConfigurationMailSetting.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    },
    [_BrandConfigurationMailSetting.mutations.addNewItem] (state, payload) {
      if (state.brandConfigurationMailSettings === null) {
        state.brandConfigurationMailSettings = []
      }
      state.brandConfigurationMailSettings.push(payload)
    },
    [_BrandConfigurationMailSetting.mutations.removeItem] (state, payload) {
      state.brandConfigurationMailSettings.splice(payload, 1)
    }
  },
  actions: {
    [_BrandConfigurationMailSetting.actions.saveBrandConfigurationMailSettings] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      payload.forEach(function (v, i, o) {
        const data = JSON.stringify(v)

        if (v.id === null) {
          var url = API_URL + '/api/v1/brandConfigurationMailSettings'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/brandConfigurationMailSettings/' + v.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_BrandConfigurationMailSetting.actions.loadBrandConfigurationMailSettings] (context, payload) {
      console.log('loadBrandConfigurationMailSettings: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/brandConfigurationMailSettings'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationMailSetting.mutations.setBrandConfigurationMailSettings, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfigurationMailSetting.actions.loadAllBrandConfigurationMailSettings] (context, payload) {
      var url = API_URL + '/api/v1/brandConfigurationMailSettings'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationMailSetting.mutations.setAllBrandConfigurationMailSettings, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfigurationMailSetting.actions.removeItem] (context, payload) {
      const tempItems = context.getters.brandConfigurationMailSettings
      const id = tempItems[payload].id

      if (id === null) {
        context.commit(_BrandConfigurationMailSetting.mutations.removeItem, payload)
        return
      }

      var url = API_URL + '/api/v1/brandConfigurationMailSettings/' + id

      console.log('remove item: ' + id)

      store.commit(Settings.mutations.setLoading, true)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_BrandConfigurationMailSetting.mutations.removeItem, payload)
        SuccessHandler.handleApiSuccess(store, r.data.message)
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_BrandConfigurationMailSetting.actions.openCloseDialog] ({ commit }) {
      commit(_BrandConfigurationMailSetting.mutations.setOpenCloseDialogState)
    },
    [_BrandConfigurationMailSetting.actions.setSelectedBrandConfigurationMailSettings] ({ commit }, payload) {
      commit(_BrandConfigurationMailSetting.mutations.setSelectedBrandConfigurationMailSettings, payload)
    },
    [_BrandConfigurationMailSetting.actions.addNewItem] ({ commit }, payload) {
      commit(_BrandConfigurationMailSetting.mutations.addNewItem, payload)
    },
    [_BrandConfigurationMailSetting.actions.resetState] ({ commit }, payload) {
      commit(_BrandConfigurationMailSetting.mutations.setBrandConfigurationMailSettings, [])
      commit(_BrandConfigurationMailSetting.mutations.setAllBrandConfigurationMailSettings, [])
      commit(_BrandConfigurationMailSetting.mutations.setSelectedBrandConfigurationMailSettings, null)
    }
  },
  getters: {
    [_BrandConfigurationMailSetting.getters.brandConfigurationMailSettings] (state) {
      return state.brandConfigurationMailSettings
    },
    [_BrandConfigurationMailSetting.getters.getAllBrandConfigurationMailSettings] (state) {
      return state.allBrandConfigurationMailSettings
    },
    [_BrandConfigurationMailSetting.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_BrandConfigurationMailSetting.getters.getSelectedBrandConfigurationMailSettings] (state) {
      return state.selectedBrandConfigurationMailSetting
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/BrandConfiguration/brandConfigurationsMailSettings.js